import { useMemo } from "react";
import headerImage from "../../assets/images/header.png";
import { Link } from "react-router";
const disabledRoutes = ["/closed", "/out-of-hours", "/pre-entry"];
export default function Header() {
  const pathname = window.location.pathname;
  const isDisabled = useMemo(() => {
    return disabledRoutes.includes(pathname);
  }, [pathname]);
  return (
    <header>
      <Link
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: isDisabled ? "default" : "pointer",
        }}
        to={`${isDisabled ? "#" : "/"}`}
        aria-disabled={isDisabled}
      >
        <img src={headerImage} alt="Burger King header" />
      </Link>
    </header>
  );
}
